var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C10.0833 19.5 8.41319 18.8646 6.98958 17.5938C5.56597 16.3229 4.75 14.7361 4.54167 12.8333H6.25C6.44444 14.2778 7.08681 15.4722 8.17708 16.4167C9.26736 17.3611 10.5417 17.8333 12 17.8333C13.625 17.8333 15.0035 17.2674 16.1354 16.1354C17.2674 15.0035 17.8333 13.625 17.8333 12C17.8333 10.375 17.2674 8.99653 16.1354 7.86458C15.0035 6.73264 13.625 6.16667 12 6.16667C11.0417 6.16667 10.1458 6.38889 9.3125 6.83333C8.47917 7.27778 7.77778 7.88889 7.20833 8.66667H9.5V10.3333H4.5V5.33333H6.16667V7.29167C6.875 6.40278 7.73958 5.71528 8.76042 5.22917C9.78125 4.74306 10.8611 4.5 12 4.5C13.0417 4.5 14.0174 4.69792 14.9271 5.09375C15.8368 5.48958 16.6285 6.02431 17.3021 6.69792C17.9757 7.37153 18.5104 8.16319 18.9062 9.07292C19.3021 9.98264 19.5 10.9583 19.5 12C19.5 13.0417 19.3021 14.0174 18.9062 14.9271C18.5104 15.8368 17.9757 16.6285 17.3021 17.3021C16.6285 17.9757 15.8368 18.5104 14.9271 18.9062C14.0174 19.3021 13.0417 19.5 12 19.5ZM14.3333 15.5L11.1667 12.3333V7.83333H12.8333V11.6667L15.5 14.3333L14.3333 15.5Z",
    fill: "#40444D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationHistory);
export default __webpack_public_path__ + "static/media/conversation_history.5ba915e4840171022a18fd6caac55134.svg";
export { ForwardRef as ReactComponent };